import { render, staticRenderFns } from "./TrustpilotButtons.vue?vue&type=template&id=06dd0b8b&"
import script from "./TrustpilotButtons.vue?vue&type=script&lang=js&"
export * from "./TrustpilotButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports